import AccountingHomePage from '../components/homepage';
import FundOrderReconciliationPage from '../components/fund-order-reconciliation/pages';
import StockOrderReconciliationPage from '../components/stock-order-reconciliation/pages';

const accountingRoutes = [
  { path: '/accounting/home', element: <AccountingHomePage /> },
  {
    path: '/accounting/fund-order-reconciliation',
    element: <FundOrderReconciliationPage />,
  },
  {
    path: '/accounting/fund-order-reconciliation/summary',
    element: <FundOrderReconciliationPage />,
  },
  {
    path: '/accounting/stock-order-reconciliation',
    element: <StockOrderReconciliationPage />,
  },
  {
    path: '/accounting/stock-order-reconciliation/summary',
    element: <StockOrderReconciliationPage />,
  },
];

export default accountingRoutes;
